import { Box } from '@mui/material';
import { useTranscriptionBlocksFollowScroll } from '../hooks/useTranscriptionBlocksFollowScroll';
import { useTranscriptionInteractionsStore } from '../hooks/useTranscriptionInteractionsStore';
import { TranscriptionBlockData } from '../lib/transcription.types';
import { TranscriptionBlockItem } from './TranscriptionBlockItem';

type TranscriptionBlocksListProps = {
  blocks: TranscriptionBlockData[];
  activeBlockId: string | null;
};

/**
 * Scrollable list of transcript blocks; optionally auto-scrolls the active block while follow mode is on.
 */
export function TranscriptionBlocksList({ blocks, activeBlockId }: TranscriptionBlocksListProps) {
  const isBlockActive = useTranscriptionInteractionsStore((state) => state.isBlockActive);
  const followPlayback = useTranscriptionInteractionsStore((state) => state.followPlayback);
  const onUserInterruptedScroll = useTranscriptionInteractionsStore(
    (state) => state.disableFollowPlayback,
  );
  const { scrollContainerRef, activeBlockRefCallback, handleContainerScroll } =
    useTranscriptionBlocksFollowScroll({
      followPlayback,
      activeBlockId,
      onUserInterruptedScroll,
    });

  return (
    <Box
      ref={scrollContainerRef}
      onScroll={handleContainerScroll}
      sx={{
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
      }}
    >
      {blocks.map((block) => {
        const isScrollTarget = block.id === activeBlockId;

        return (
          <TranscriptionBlockItem
            key={block.id}
            ref={isScrollTarget ? activeBlockRefCallback : undefined}
            block={block}
            blockActive={isBlockActive(block.segment)}
          />
        );
      })}
    </Box>
  );
}
